/**
 * on/off controller mixin
 */

/**
 * onOffCtrlMixinFactory
 * returns onOffCtrlMixin mixin factory
 *
 * @class onOffCtrlMixinFactory
 * @memberof mwApp/common
 * @see mwApp/common
 *
 * @ngdoc factory
 * @name mwApp/common.factory:onOffCtrlMixinFactory
 */
/* @ngInject */
export default function onOffCtrlMixinFactory () {
  /**
   * Mixin with onOff controller method
   *
   * @mixin onOffCtrlMixin
   * @memberof mwApp/common
   * @see mwApp/common
   * @name mwApp/common.mixin:onOffCtrlMixin
   *
   * @type {Object}
   */
  return {
    onOff: function (entity) {
      return entity._onOff()
    }
  }
}
